import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { orderBy, cloneDeep } from 'lodash';
import * as action from '../../../store/DevelopmentOrder.action';
import Loader from '../../../../../Components/Utility/Loader/Loader';
import noImage from '../../../../../assets/images/no-image.png';
import ApproveRejectFooter from '../../../../../Components/ApproveRejectFooter/ApproveRejectFooter';
import { checkArray } from '../../../../../Components/helper';
import { useComponent } from '../../../../UserSetting/UsersLibrary/UserRights';

const MissingComponents = forwardRef(({ isProductArchived }, ref) => {
  const valueRef = useRef();
  const originalMissingComponentsDataRef = useRef([]);
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const devOrderReducer = useSelector((reducerstate) => reducerstate);
  const {
    Measuremets,
    UserDetails,
    Users: { logInRights },
  } = devOrderReducer;
  const { CheckActionPermission } = useComponent();
  const SampleEditAccess = CheckActionPermission(logInRights, 'products', 'samples', 'addEdit');
  const SampleApproveRejectAccess = CheckActionPermission(logInRights, 'products', 'samples', 'approveReject');

  const { sampleDetails, missingComponentDetails } = Measuremets;
  const { isSupplierLoggedIn } = UserDetails;

  const [state, setState] = useState({
    missingComponentsList: [],
    deleteId: null,
    pageIndex: 1,
    pageSize: 20,
    hasMore: true,
    loading: false,
    totalRecords: null,
    sortOrder: '',
    propertName: '',
    sortPropertyName: '',
    columnSortValue: 'asc',
  });

  const [loader, setLoader] = useState(false);

  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [selectedComponent, setSelectedComponent] = useState([]);
  const [isSelectAll, setSelectAll] = useState(false);
  const [productId, setProductId] = useState(false);
  const { supplier, devOrderId } = sampleDetails;

  useImperativeHandle(ref, () => ({
    getSampleMissingComponemt() {
      return (
        state.missingComponentsList?.map((item) => ({
          ...item,
          mcComment: item.mcComment || '',
        })) || []
      );
    },
    hasPendingChanges() {
      const currentData = state.missingComponentsList;
      const originalData = originalMissingComponentsDataRef.current;

      if (!currentData || !originalData) return false;
      if (currentData.length !== originalData.length) return false;

      return currentData.some((item, index) => {
        const originalItem = originalData[index];
        if (!originalItem) return false;

        return item?.mcComment !== originalItem?.mcComment;
      });
    },
  }));

  useEffect(() => {
    if (selectedIdArray.length === state.missingComponentsList?.length && selectedIdArray.length > 0) {
      setSelectAll(true);
    }
  }, [selectedIdArray]);

  const descendingOptions = () => {
    return state?.columnSortValue === 'desc' ? <i className="fa fa fa-sort-desc ml-1" /> : <i className="fa fa fa-sort-up ml-1" />;
  };

  const truthyValue = () => {
    return state?.columnSortValue === '' ? <i className="fa fa fa-sort ml-1" /> : descendingOptions();
  };

  const headerSortingIcon = (lable, propertyName) => {
    return (
      <span className="cursor-pointer">
        {lable}
        {state?.propertName === propertyName ? truthyValue() : <i className="fa fa fa-sort ml-1" />}
      </span>
    );
  };
  const onSortColumns = (key, columnSortValue) => {
    let missingComponent = state.missingComponentsList;
    let columnSortVal = columnSortValue;
    if (state.propertName !== key) {
      columnSortVal = 'asc';
    } else if (columnSortVal === 'asc') {
      columnSortVal = 'desc';
    } else if (columnSortVal === 'desc') {
      columnSortVal = 'asc';
    }

    missingComponent = orderBy(
      missingComponent,
      (o) => {
        if (!isNaN(Number(o[key]))) {
          return +o[key];
        }
        return o[key];
      },
      [columnSortVal],
    );

    setState((prevState) => ({
      ...prevState,
      propertName: key,
      columnSortValue: columnSortVal,
      missingComponentsList: missingComponent,
    }));
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedIdArray([]);
      setSelectedComponent([]);
    } else {
      const selectedItems = [...selectedIdArray];
      const allMissingComponent = [];
      for (const item of state.missingComponentsList) {
        const findItems = selectedItems.filter((val) => val === item.uId);
        if (findItems.length === 0) {
          selectedItems.push(item.uId);
        }
        allMissingComponent.push(item);
      }
      setSelectedIdArray(selectedItems);
      setSelectedComponent(allMissingComponent);
    }
    setSelectAll(!isSelectAll);
  };

  const onSelectCheckBox = async (e, id) => {
    let selectedItems = [...selectedIdArray];

    if (e.target.checked) {
      setSelectedIdArray([...selectedItems, id]);
      const checkedComponent = state.missingComponentsList.filter((item) => item.uId === id);
      setSelectedComponent([...selectedComponent, checkedComponent[0]]);
    } else {
      setSelectAll(false);
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
      const checkedComponent = state.missingComponentsList.filter((item) => selectedItems.includes(item.uId));

      setSelectedComponent(checkedComponent);
    }
  };
  const getMissingComponent = async (supplierDetail, _productId) => {
    setLoader(true);
    const objData = {
      supplierId: supplierDetail?._id,
    };
    supplierDetail?._id && _productId && (await dispatch(action.getSampleMissingComponent(_productId, objData)));
    setLoader(false);
  };

  const handleCommentChange = (e, i) => {
    const copydata = [...state.missingComponentsList];
    copydata[i].mcComment = e.target.value;

    setState({ missingComponentsList: copydata });
  };
  const handleApproval = async (data) => {
    const objParam = {
      bomApprove: {
        selectedDate: data[1].commentDate,
        status: parseInt(data[1].status),
        comment: data[1].comment,
        approveBy: data[1]?.approveBy,
      },
      devOrderId: productId,
      isMissingComponents: true,
      libs: selectedComponent,
    };
    const res = await dispatch(action.saveSampleMissingComp(objParam, t));
    if (res) {
      setSelectedComponent([]);
      setSelectedIdArray([]);
    }
    getMissingComponent(supplier, devOrderId);
  };
  useEffect(() => {
    setProductId(devOrderId);
    getMissingComponent(supplier, devOrderId);
  }, [sampleDetails]);

  useEffect(() => {
    if (missingComponentDetails) {
      setState({ ...state, missingComponentsList: missingComponentDetails });
      originalMissingComponentsDataRef.current = cloneDeep(missingComponentDetails);
    }
  }, [missingComponentDetails]);
  const autoSave = async () => {
    const objMissingComp = {
      libs: valueRef.current,
      devOrderId,
      isMcComment: true,
      isMissingComponents: true,
    };
    devOrderId && dispatch(action.saveSampleMissingComp(objMissingComp, t, 'tosterOff'));
  };
  useEffect(() => {
    valueRef.current = state.missingComponentsList;
  }, [state.missingComponentsList]);
  useEffect(() => {
    return () => {
      autoSave();
    };
  }, []);
  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="table-responsive pb-4">
          <table className="table common-custom-table mt-16">
            <thead>
              <tr>
                {!isSupplierLoggedIn && (
                  <th className="w-80px">
                    <div className="common-checkbox margin-auto">
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        name="check_all"
                        id="check_all"
                        checked={isSelectAll}
                        disabled={(!state.missingComponentsList?.length, isProductArchived)}
                      />
                      <label htmlFor="check_all" className="chklabel">
                        <span />
                      </label>
                    </div>
                  </th>
                )}
                <th className="w-80px">{t('SAMPLES.MISSING_COMPONENT.IMAGE')}</th>
                <th
                  className="w-150px"
                  onClick={() => {
                    onSortColumns('bomType', state.columnSortValue);
                  }}
                >
                  {headerSortingIcon(t('SAMPLES.MISSING_COMPONENT.BOM_COMPONENT'), t('SAMPLES.MISSING_COMPONENT.BOM_TYPE'))}
                </th>

                <th
                  className="w-150px"
                  onClick={() => {
                    onSortColumns('referenceCode', state.columnSortValue);
                  }}
                >
                  {headerSortingIcon(t('SAMPLES.MISSING_COMPONENT.REFRENCE_CODE'), t('SAMPLES.MISSING_COMPONENT.REFRENCE'))}
                </th>

                <th
                  className="w-250px"
                  onClick={() => {
                    onSortColumns('description', state.columnSortValue);
                  }}
                >
                  {headerSortingIcon(t('SAMPLES.MISSING_COMPONENT.DESCRIPTION'), t('SAMPLES.MISSING_COMPONENT.DESCRPTIONS'))}
                </th>

                <th
                  className="w-120px"
                  onClick={() => {
                    onSortColumns('libType', state.columnSortValue);
                  }}
                >
                  {headerSortingIcon(t('SAMPLES.MISSING_COMPONENT.TYPE'), t('SAMPLES.MISSING_COMPONENT.LIB_TYPE'))}
                </th>

                <th
                  className="w-150px"
                  onClick={() => {
                    onSortColumns('approval', state.columnSortValue);
                  }}
                >
                  {headerSortingIcon(t('SAMPLES.MISSING_COMPONENT.QUALITY_COLOUR'), t('SAMPLES.MISSING_COMPONENT.APPROVAL'))}
                </th>

                <th
                  className="w-200px"
                  onClick={() => {
                    onSortColumns('libStatus', state.columnSortValue);
                  }}
                >
                  {headerSortingIcon(t('SAMPLES.MISSING_COMPONENT.STATUS_DATE'), t('SAMPLES.MISSING_COMPONENT.LIB_STATUS'))}
                </th>
                <th className="w-250px">{t('SAMPLES.MISSING_COMPONENT.COMMENTS')}</th>
              </tr>
            </thead>

            <tbody>
              {checkArray(state.missingComponentsList) &&
                state.missingComponentsList.map((item, i) => (
                  <tr key={i}>
                    {!isSupplierLoggedIn && (
                      <td>
                        <div className="common-checkbox margin-auto">
                          <input
                            onChange={(e) => {
                              onSelectCheckBox(e, item?.uId);
                            }}
                            name={`checks_${i}`}
                            id={`checks_${i}`}
                            type="checkbox"
                            checked={selectedIdArray.filter((val) => val === item?.uId).length > 0}
                            disabled={isProductArchived}
                          />
                          <label htmlFor={`checks_${i}`} className="chklabel">
                            <span />
                          </label>
                        </div>
                      </td>
                    )}

                    <td>
                      <img width="60" src={item?.image || noImage} alt="croppedImage" />
                    </td>
                    <td>{item.bomType}</td>
                    <td>{item.referenceCode}</td>
                    <td>{item.description}</td>
                    <td>{item.libType}</td>
                    <td>{item.approval}</td>
                    <td>
                      {item?.libStatus}
                      {item?.commentDate !== '' && item?.commentDate !== null && (
                        <>
                          {' at '}
                          {moment(item?.commentDate).format('Do MMM YYYY')}
                        </>
                      )}
                      <p className="mt-1 mb-0">{item?.comment !== '' && item.comment}</p>
                    </td>
                    <td>
                      <div className="common-input-control mb-0">
                        <input
                          type="text"
                          className="form-control input-border "
                          placeholder={t('DEVLOPMENT_ORDER.SAMPLES.SAMPLE_DETAILS.MISSING_COMPONENET.COMMENT')}
                          value={item?.mcComment ?? ''}
                          name={`missingComponent[${i}].mcComment`}
                          disabled={(!SampleEditAccess, isProductArchived)}
                          onChange={(e) => handleCommentChange(e, i)}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              {!state.loading && state.missingComponentsList.length === 0 && (
                <tr className="text-center">
                  <td colSpan={9}> {t('SAMPLES.MISSING_COMPONENT.NO_MISSING_COMPONENET_FOUND')}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {SampleApproveRejectAccess && selectedIdArray.length > 0 && (
        <ApproveRejectFooter devOrderId={productId} onSave={(...data) => handleApproval(data)} selectedIdArray={selectedIdArray} fromSampleMissingComponent />
      )}
    </>
  );
});
MissingComponents.displayName = 'MissingComponents';
export default MissingComponents;
